var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 overflow-hidden"},[(_vm.harvester && _vm.task)?_c(_vm.harvester.component,{tag:"component",attrs:{"task":_vm.task,"steps":_vm.harvester.steps,"loading":_vm.loading}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }